var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "round_localisation_light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round_localisation_light",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Location/"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.166667, 22.666667)",
    id: "Group",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0470885,13.2017544 C17.0470885,11.0526316 15.6631919,9.70175442 13.4615385,9.70175442 C11.259885,9.70175442 9.87598848,11.0526316 9.87598848,13.2017544 C9.87598848,15.3508772 11.259885,16.7017544 13.4615385,16.7017544 C15.6631919,16.7017544 17.0470885,15.3508772 17.0470885,13.2017544 M19.1858375,13.2017544 C19.1858375,16.3333333 16.7325665,18.7280702 13.4615385,18.7280702 C10.1905104,18.7280702 7.73723944,16.3333333 7.73723944,13.2017544 C7.73723944,10.0087719 10.1905104,7.67543857 13.4615385,7.67543857 C16.7325665,7.67543857 19.1858375,10.0087719 19.1858375,13.2017544 M24.6585191,12.5877193 C24.6585191,6.38596492 20.1294033,2.0877193 13.4615385,2.0877193 C6.79367368,2.0877193 2.26455786,6.38596492 2.26455786,12.5877193 C2.26455786,18.1754387 6.47915169,25.9122808 13.4615385,32.9736842 C20.4439253,25.9122808 24.6585191,18.1754387 24.6585191,12.5877193 M-1.30431796e-15,12.5877192 C-1.30431796e-15,5.03508771 5.40977713,-9.7823847e-16 13.4615385,-9.7823847e-16 C21.5132998,-9.7823847e-16 26.9230769,5.03508771 26.9230769,12.5877192 C26.9230769,18.7894737 22.1423436,27.4473684 14.5938174,35 L12.3292596,35 C4.78073329,27.4473684 -1.30431796e-15,18.7894737 -1.30431796e-15,12.5877192",
    id: "Location"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b5b8eae76291223d7228b56579852aa0.svg";
export { ForwardRef as ReactComponent };